import { FoodModel } from './diet-food-model';

export class DietsModel {
  constructor(public diets: DietModel[], public updatedAt: string) {}

  static fromJSON(json: DietsModelJSON | string): DietsModel {
    if (typeof json === 'string') {
      // if it's a string, parse it first
      return JSON.parse(json, DietsModel.reviver);
    } else {
      // create an instance of the User class
      const diets = Object.create(DietsModel.prototype);
      // copy all the fields from the json object
      return Object.assign(diets, json);
    }
  }

  static reviver(key: string, value: any): any {
    return key === '' ? DietsModel.fromJSON(value) : value;
  }
}

export class DietModel {
  constructor(
    public difficulty: string,
    public isCanceled: boolean,
    public hatedFoods: string[],
    public diseases: string[],
    public pregnancyDate: number,
    public breastFeedingDate: number,
    public specialTypes: string[],
    public _id: string,
    public days: DietDayModel[],
    public startWeight: number,
    public activity: string,
    public startDate: number,
    public endDate: number,
    public goal: string,
    public calorie: number,
    public updatedAt: string,
    public createdAt: string,
    public type: TypeModel,
    public fasting: FastingModel
  ) {}
}

export class FastingModel {
  constructor(
    public fasting: number,
    public fastingCalorie: number,
    public fastingTime: number,
    public fastingDays: number[],
    public name: string,
    public type: string
  ) {}
}

export class TypeModel {
  constructor(
    public description: string,
    public isPersonal: boolean,
    public name: string,
    public fasting: number,
    public mealRatioArray: MealRatioArray[],
    public type: string
  ) {}
}

export class MealRatioArray {
  constructor(
    public mealRatios: MealRatio[],
    public type: string,
    public _id: string
  ) {}
}

export class MealRatio {
  constructor(
    public _id: string,
    public meal: string,
    public ratio: number,
    public meal_text: string
  ) {}
}

export class DietDayModel {
  constructor(
    public isCheatDay: boolean,
    public _id: string,
    public day: string,
    public meals: DietMealModel[]
  ) {}
}

export class DietMealModel {
  constructor(
    public status: string,
    public _id: string,
    public meal: string,
    public foods: DietFoodModel[]
  ) {}
}

export class DietFoodModel {
  constructor(
    public name: string,
    public _id: string,
    public food: string,
    public foodModel: FoodModel,
    public amount: number,
    public unit: string
  ) {}
}

export interface DietsModelJSON {
  diets: DietModel[];
  updatedAt: string;
}

export class DietSearchMealModel {
  constructor(
    public _id: string,
    public meal: string,
    public foods: DietSearchFoodModel[],
    public amounts: DietSearchAmountModel[]
  ) {}
}

export class DietSearchAmountModel {
  constructor(public amount: number) {}
}

export class DietSearchFoodModel {
  constructor(public _id: string, public foodId: FoodModel) {}
}

export class DietSearchedFoodModel {
  constructor(public _id: string, public name: string) {}
}
